/*
 * AchievementDetails Messages
 *
 * This contains all the text for the AchievementDetails component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.AchievementDetails';

export default defineMessages({
  event: {
    id: `${scope}.event`,
    defaultMessage: 'Event',
  },
  condition: {
    id: `${scope}.condition`,
    defaultMessage: 'Condition',
  },
  result: {
    id: `${scope}.result`,
    defaultMessage: 'Result',
  },
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Start date',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  requestConfirmation: {
    id: `${scope}.requestConfirmation`,
    defaultMessage: 'Request for Confirmation',
  },
  sendRequest: {
    id: `${scope}.sendRequest`,
    defaultMessage: 'Send Request',
  },
});
